import React from 'react'
import './style.css'

const QuickView = ({ data, icon: Icon, footer, iconColor, backgroundColor }) => {
  const iconStyles = {
    fontSize: '30px',
    width: '30px',
    height: '30px',
    color: iconColor || 'inherit' // Default to 'inherit' if no iconColor is provided
  };

  const containerStyles = {
    backgroundColor: backgroundColor || 'transparent' // Default to 'transparent' if no backgroundColor is provided
  };

  return (
    <div className="card quick-details-dashbaord-container">
      <div className="flex-container">
        <div className="quick-info-data">{data}</div>
        <div className="quick-info-icon-container" style={containerStyles}>
          <Icon style={iconStyles} />
        </div>
      </div>
      <br />
      <div className="quick-info-container-footer">{footer}</div>
    </div>
  );
}

export default QuickView
